import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { DestinatarioDipendenteDTO } from "@app/shared/dto/gescor/destinatario-dipendenteDTO";
import { DipendenteDTO } from "@app/shared/dto/dipendenteDTO";
import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";
import { DipendenteVO } from "@app/shared/vo/dipendenteVO";
import { DestinatarioDipendenteVO } from "@app/shared/vo/gescor/destinatario-dipendenteVO";
import { MapperDipendente } from "./mapper-dipendente";

@Injectable({
  providedIn: "root"
})
export class MapperDestinatarioDipendente
  implements
  MapperInterface<DestinatarioDipendenteDTO, DestinatarioDipendenteVO> {
  constructor(private mapperDipendente: MapperDipendente) { }

  convertVoToDto(e: DestinatarioDipendenteVO): DestinatarioDipendenteDTO {
    const destinatarioDipendenteDTO = new DestinatarioDipendenteDTO();
    destinatarioDipendenteDTO.competenza = e.competenza;
    let dipendenteDTO = new DipendenteDTO();
    dipendenteDTO = this.mapperDipendente.convertVoToDto(e.dipendente);
    destinatarioDipendenteDTO.dipendente = dipendenteDTO;
    return destinatarioDipendenteDTO || new DestinatarioDipendenteDTO();
  }
  convertDtoToVo(t: DestinatarioDipendenteDTO): DestinatarioDipendenteVO {
    const destinatarioDipendenteVO = new DestinatarioDipendenteVO();

    if (t.competenza !== null && t.competenza.toString() === "PER_CONOSCENZA") {
      destinatarioDipendenteVO.competenza = TipoDestinatarioEnum.PER_CONOSCENZA.valueOf();
    }
    if (t.competenza !== null && t.competenza.toString() === "DIRETTO") {
      destinatarioDipendenteVO.competenza = TipoDestinatarioEnum.DIRETTO.valueOf();
    }
    let dipendenteVO = new DipendenteVO();
    dipendenteVO = this.mapperDipendente.convertDtoToVo(t.dipendente);
    destinatarioDipendenteVO.dipendente = dipendenteVO;
    return destinatarioDipendenteVO || new DestinatarioDipendenteVO();
  }
  convertListVoToDto(
    t: DestinatarioDipendenteVO[]
  ): DestinatarioDipendenteDTO[] {
    const destinatarioDipendenteDTOList = new Array<
      DestinatarioDipendenteDTO
    >();
    if (t != null) {
      t.forEach((destinatarioDipendenteVO) => {
        destinatarioDipendenteDTOList.push(
          this.convertVoToDto(destinatarioDipendenteVO)
        );
      });
    }
    return (
      destinatarioDipendenteDTOList || new Array<DestinatarioDipendenteVO>()
    );
  }

  convertListDtoToVo(
    t: DestinatarioDipendenteDTO[]
  ): DestinatarioDipendenteVO[] {
    const destinatarioDipendenteVOList = new Array<DestinatarioDipendenteVO>();
    if (t != null) {
      t.forEach((destinatarioDipendenteDTO) => {
        if (destinatarioDipendenteDTO !== null) {
          destinatarioDipendenteVOList.push(
            this.convertDtoToVo(destinatarioDipendenteDTO)
          );
        }
      });
    }
    return (
      destinatarioDipendenteVOList || new Array<DestinatarioDipendenteVO>()
    );
  }
}
